<script setup>
import { computed, nextTick, onBeforeUnmount, onMounted } from 'vue';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { usePageSeo } from '../composables/usePageSeo.js';
import { siteUrl } from '../data/resources.js';
import HeroSection from '../components/HeroSection.vue';
import CategoriesSection from '../components/CategoriesSection.vue';
import JourneySection from '../components/JourneySection.vue';
import FeaturedSection from '../components/FeaturedSection.vue';
import CentersSection from '../components/CentersSection.vue';
import ToolsSection from '../components/ToolsSection.vue';
import ResearchSection from '../components/ResearchSection.vue';
import MediaSection from '../components/MediaSection.vue';
import ContributionSection from '../components/ContributionSection.vue';
import { initHomepage } from '../legacy/homepage.js';
import { useRouter } from 'vue-router';

const router = useRouter();
let cleanupHomepage = () => {};

usePageSeo(computed(() => ({
  title: 'الدليل إلى السنة النبوية | منظومة خدمة السنة',
  description: 'دليل شامل لمشاريع خدمة السنة النبوية وعلومها من مواقع وتطبيقات ومراكز وبحوث ومواد مرئية وصوتية.',
  canonical: `${siteUrl}/`,
  robots: 'index,follow',
  ogTitle: 'الدليل إلى السنة النبوية',
  ogDescription: 'اكتشف منظومة خدمة السنة النبوية ومواردها الموثوقة.',
  path: '/',
  schema: { '@context':'https://schema.org', '@type':'Organization', name:'الدليل إلى السنة النبوية', url:`${siteUrl}/` }
})));

onMounted(() => nextTick(() => {
  window.__homepageInitialized = false;
  cleanupHomepage = initHomepage(router) || (() => {});
}));

onBeforeUnmount(() => {
  cleanupHomepage();
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  window.__centersMap?.remove?.();
  window.__centersMap = null;
  window.__homepageInitialized = false;
});
</script>

<template>
  <main id="main">
    <HeroSection />
    <CategoriesSection />
    <JourneySection />
    <FeaturedSection />
    <CentersSection />
    <ToolsSection />
    <ResearchSection />
    <MediaSection />
    <ContributionSection />
  </main>
</template>
